"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const About_1 = require("../../frontend/components/About");
const Home_1 = require("../../frontend/components/Home");
const Blog_1 = require("../../frontend/components/Blog");
const SinglePost_1 = require("../../frontend/components/SinglePost");
const BlogActions_1 = require("../../frontend/actions/BlogActions");
const CustomActions_1 = require("../../frontend/actions/CustomActions");
const Galleries_1 = require("../../frontend/components/Galleries");
const GalleryView_1 = require("../../frontend/components/GalleryView");
const EntitiesActions_1 = require("../../frontend/actions/EntitiesActions");
const NotFound_1 = require("../../frontend/components/NotFound");
const BlogStore_1 = require("../../frontend/stores/BlogStore");
exports.default = {
    home: {
        path: '/',
        isInMenu: true,
        method: 'get',
        page: 'home',
        title: '{0}',
        handler: Home_1.default,
        action: (context, payload, done) => {
            context.executeAction(CustomActions_1.default.GetMapLocs, {}, done);
        },
    },
    blog: {
        path: '/blog',
        isInMenu: true,
        method: 'get',
        page: 'blog',
        title: 'Travels Posts - {0}',
        handler: Blog_1.default,
        action: (context, payload, done) => {
            context.executeAction(BlogActions_1.default.getPosts, JSON.parse(JSON.stringify(payload.query)), done);
        },
    },
    post: {
        path: '/post/:slug',
        method: 'get',
        page: 'singlePost',
        title: '',
        handler: SinglePost_1.default,
        action: (context, payload, done) => {
            const slug = payload.params.slug;
            if (context.getStore(BlogStore_1.default).getSinglePost()
                && context.getStore(BlogStore_1.default).getSinglePost().slug === slug) {
                return;
            }
            context.executeAction(BlogActions_1.default.getCurrentPost, {
                slug,
            }, done);
        },
    },
    gallery: {
        path: '/album/:name',
        isInMenu: false,
        method: 'get',
        page: 'galleries',
        title: '',
        handler: GalleryView_1.default,
        action: (context, payload, done) => {
            context.executeAction(EntitiesActions_1.default.getGallery, {
                name: payload.params.name,
            }, done);
        },
    },
    albums: {
        path: '/albums',
        isInMenu: true,
        method: 'get',
        page: 'albums',
        title: 'Albums - {0}',
        handler: Galleries_1.default,
        action: (context, payload, done) => {
            context.executeAction(EntitiesActions_1.default.getGalleries, {}, done);
        },
    },
    about: {
        path: '/about',
        isInMenu: true,
        method: 'get',
        page: 'about',
        title: 'About xbIm - {0}',
        handler: About_1.default,
    },
    notFound: {
        path: '/404',
        isInMenu: false,
        method: 'get',
        page: 'Not Found',
        title: 'Not Found - {0}',
        handler: NotFound_1.default,
    },
};
